import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import PopupContent from "./PopupContent";
import SubcategoryFragment from "./SubcategoryFragment";
import TrowFragment from "./TrowFragment";


export default class DirectoryMenu extends React.Component {
  state = {};
  handleMenuToggle = () => {
    this.props.handleMenuToggle(this.props.title);
  }

  componentDidMount() {
    this.getStyle();
    window.addEventListener('resize', () => this.getStyle());
    document.addEventListener('scroll', () => this.getStyle());
  }

  getStyle = () => {
    const parent = document.getElementById('dir-menu-rect');
    const rect = parent.getBoundingClientRect();
    this.setState({ parent, rect })
  }

  render() {
    const { open } = this.props;
    return (
      <button id="dir-menu-rect" className={cx("closed-menu", "dir-menu", {open: open})} onClick={this.props.handleMenuToggle}>
        <h3>{this.props.title}</h3>
        {open && (
          <div className="opened">
          <PopupContent top={this.state.rect.top} left={this.state.rect.right+5}>
      
              {this.props.dirs.map(
                (d) => (<TrowFragment onEvent={this.props.onEvent} dir={d} />))
              }

          </PopupContent>
          </div>
        )}
      </button>
    );
  }
}

DirectoryMenu.propTypes = {
  title: PropTypes.string,
  menuItems: PropTypes.array,
  onClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/DirectoryMenu.js